import { CDN_URL_GIF, CDN_URL_MEDIA, CDN_URL_VIDEO } from "~/env";

//////////////////////////////////////
// =============== MP4 ===============
//////////////////////////////////////

// 小理ai
export const XiaoLiAi = `${CDN_URL_VIDEO}/www/487eb247.mp4`;

// 得理法搜
export const FaSou = `${CDN_URL_VIDEO}/www/2cb4c17e.mp4`;

// 得理律助
export const LvZhu = `${CDN_URL_VIDEO}/www/27025b60.mp4`;

// 传统文书
export const DocumentExample = `${CDN_URL_VIDEO}/data/cba1be48.mp4`;

// 文本分析
export const TextExample = `${CDN_URL_VIDEO}/data/3d30ec08.mp4`;

// 法律研究
export const LawsExample = `${CDN_URL_VIDEO}/data/f6170275.mp4`;

// 合同审查
export const ReviewExample = `${CDN_URL_VIDEO}/data/e49985d5.mp4`;

// 合同生成
export const GenerateExample = `${CDN_URL_VIDEO}/data/a1b74354.mp4`;

// 要素文书
export const ElementsExample = `${CDN_URL_VIDEO}/data/d6bf9cbe.mp4`;

// ai检索+ai法规
export const AiSearchExample = `${CDN_URL_VIDEO}/data/a1f243d4.mp4`;

//小理智能体
export const AgentExample = `${CDN_URL_VIDEO}/dls/d9b95df5.mp4`;

//案件管理
export const CaseManagement = `${CDN_URL_VIDEO}/dls/a79404be.mp4`;

//案源拓展
export const AnYuanTuoZhan = `${CDN_URL_VIDEO}/dls/b6025c6b.mp4`;

//知识管理
export const ZhiShiGuanLi = `${CDN_URL_VIDEO}/dls/37216310.mp4`;

//////////////////////////////////////
// =============== GIF ===============
//////////////////////////////////////

// 数字名片
export const ShuZiMingPian = `${CDN_URL_MEDIA}/dls/d248ca7a54ecf6e78601cf4a1b49419d/d248ca7a54ecf6e78601cf4a1b49419d.gif`;

// 案源广场
export const AnYuanGuangChang1 = `${CDN_URL_MEDIA}/dls/480d645a21a9d0f3f2b1adf0a0ed8fd4/480d645a21a9d0f3f2b1adf0a0ed8fd4.gif`;

// 商机推送
export const ShangJiTuiSong = `${CDN_URL_GIF}/b5f10bb5.gif`;

// 同行合作
export const TongXingHeZuo = `${CDN_URL_MEDIA}/dls/bf45cb3a0ff50f3256bf352f46ca6e1a/bf45cb3a0ff50f3256bf352f46ca6e1a.gif`;

// 文档管理
export const WenDangGuanLi = `${CDN_URL_MEDIA}/dls/bec416b7596d38badbf8901c72468db8/bec416b7596d38badbf8901c72468db8.gif`;

// 小理智能体
export const XiaoLiZhiNengTi = `${CDN_URL_MEDIA}/dls/73b510a181e9c991787d85ba225895fd/73b510a181e9c991787d85ba225895fd.gif`;

// 法律检索
export const FaLvJianSuo = `${CDN_URL_MEDIA}/dls/fef8dc14c2da7990f8d77beb5b309c69/fef8dc14c2da7990f8d77beb5b309c69.gif`;

// AI阅读裁判文书
export const AiYueDuCaiPanWenShu = `${CDN_URL_MEDIA}/dls/5551dfb197e59c5ab453dd623fd1f850/5551dfb197e59c5ab453dd623fd1f850.gif`;

// 生成起诉书
export const ShengChengQiSuShu = `${CDN_URL_MEDIA}/dls/ebdc5e45fa27457ace2154cf29f51da4/ebdc5e45fa27457ace2154cf29f51da4.gif`;

// 法律研究
export const FaLvYanJiu = `${CDN_URL_GIF}/1043612e.gif`;

// 法律咨询
export const FaLvZiXun = `${CDN_URL_GIF}/caf8bbae.gif`;

// 法律资讯推荐
export const FaLvZiXunTuiJian = `${CDN_URL_MEDIA}/dls/703c4e8009be701d70679ea0015a1987/703c4e8009be701d70679ea0015a1987.gif`;

// 文档分析
export const WenDangFenXi = `${CDN_URL_MEDIA}/dls/64a786000b7353582f958fa85ee0ea2e/64a786000b7353582f958fa85ee0ea2e.gif`;

// 文本分析
export const WenBenFenXi = `${CDN_URL_GIF}/58bae102.gif`;

// 文案创作
export const WenAnChuangZuo = `${CDN_URL_GIF}/a0882982.gif`;

// 律师智能推荐
export const WenShiShi = `${CDN_URL_MEDIA}/dls/46b6fcde0e50921d5e3104e6d9eedebd/46b6fcde0e50921d5e3104e6d9eedebd.gif`;

// 合同审查
export const HeTongShenCha = `${CDN_URL_GIF}/c4c8f9e7.gif`;

// 律师函
export const LvShiHan = `${CDN_URL_GIF}/62772C2D66C8F99A82BFCF812566A8EF.gif`;

// 合同生成
export const HeTongShengCheng = `${CDN_URL_GIF}/a6a4f0bc.gif`;

// 文书ai
export const WenShuAi = `${CDN_URL_GIF}/7CD45A77B995B96DF09669C0FA1003F9.gif`;

// ai法律咨询
export const AiFaLvZiXun = `${CDN_URL_GIF}/F941F54C45F6BDB296A53410A5BA452E.gif`;

// 合规ai
export const HeGuiAi = `${CDN_URL_GIF}/70A1065C11756918702BAD4794DF0B1A.gif`;

//问律师
export const WenLvShi = `${CDN_URL_GIF}/993b2059.gif`;

//AI检索
export const AiJianSuo = `${CDN_URL_GIF}/fbc5be70.gif`;

//内部市场
export const NeiBuShiChang = `${CDN_URL_GIF}/38c4db78.gif`;

//法律文书
export const FaLvWenShu = `${CDN_URL_GIF}/86dd3f04.gif`;

//知识库
export const ZhiShiKu = `${CDN_URL_GIF}/9d6ff0fe.gif`;

///////////////////////////////////////
// =============== JSON ===============
///////////////////////////////////////
// 律师入驻 lottie 动画 json
export const SettlementJson = `${CDN_URL_MEDIA}/dls/912666ea05993388276ca2eb6e0ebc37/912666ea05993388276ca2eb6e0ebc37.json`;
